module.exports = __webpack_public_path__ + "img/Opplysningstiden_Mozart-spiller.e385e24a.jpg";